module.exports = __webpack_public_path__ + "img/MO.7459805c.png";